module.exports = __webpack_public_path__ + "static/favicon-2d49fd1ab7c3d88debed55e3c01d5a3a.ico";